/* @flow */
import * as React from 'react';
import { uniqueId } from 'lodash/fp';
import withNotificationCallback from './withNotificationCallback';
import styled from '@emotion/styled';

type Props = {
  children: any,
  confirmText?: string,
  onClose?: () => void,
  onConfirm?: () => void,
  persist?: boolean,
  removeNotification: string => void,
  transmitNotification: Object => void,
  type: 'danger' | 'info' | 'success' | 'warning'
};

class Notification extends React.Component<Props> {
  props: Props;

  id: string = uniqueId('NOTIFICATION_COMPONENT_'); // eslint-disable-line react/sort-comp

  static defaultProps = {
    confirmText: undefined,
    onClose: undefined,
    onConfirm: undefined,
    persist: false
  };

  componentDidMount() {
    this.props.transmitNotification({
      id: this.id,
      message: <TextContainer>{this.props.children}</TextContainer>,
      confirmText: this.props.confirmText,
      onClose: this.props.onClose,
      onConfirm: this.props.onConfirm,
      persist: this.props.persist,
      type: this.props.type
    });
  }

  componentDidUpdate() {
    this.props.transmitNotification({
      id: this.id,
      message: <TextContainer>{this.props.children}</TextContainer>,
      confirmText: this.props.confirmText,
      onClose: this.props.onClose,
      onConfirm: this.props.onConfirm,
      persist: this.props.persist,
      type: this.props.type
    });
  }

  componentWillUnmount() {
    this.props.removeNotification(this.id);
  }

  render() {
    return null;
  }
}

export default withNotificationCallback(Notification);

const TextContainer = styled.div`
  color: #000000;
`;
